import { defineComponent as _defineComponent } from 'vue';
import { BOverlay, BFormRadioGroup, BFormRadio } from 'bootstrap-vue';
import GlazingOption from 'public/components/picture-frames/Value/GlazingOption.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { useAxios } from 'composables/useAxios';
import debounce from 'lodash/debounce';
import { getSheetPrice } from 'public/modules/pricing';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GlazingOptions',
    props: {
        value: null,
        groupId: null,
        frameSize: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedGlazing = computed({
            get: () => props.value,
            set: v => emit('input', v)
        });
        const loading = ref(true);
        const basePrice = ref('0.00');
        const glazingOptions = ref({ Standard: [], Acrylic: [], Specialist: [] });
        const axios = useAxios();
        const updateBasePrice = async () => {
            const price = await getSheetPrice('G-12', props.frameSize, true, props.groupId);
            basePrice.value = price.base_unit_price;
        };
        const debouncedUpdateBasePrice = debounce(updateBasePrice, 350);
        watch(() => props.frameSize, () => debouncedUpdateBasePrice(), { deep: true });
        onMounted(async () => {
            loading.value = true;
            const { data } = await axios.get('valueFrames/glazings');
            glazingOptions.value = data;
            emit('input', glazingOptions.value.Standard[0]);
            loading.value = false;
        });
        return { __sfc: true, props, emit, selectedGlazing, loading, basePrice, glazingOptions, axios, updateBasePrice, debouncedUpdateBasePrice, BOverlay, BFormRadioGroup, BFormRadio, GlazingOption, computed, onMounted, ref, watch, useAxios, debounce, getSheetPrice };
    }
});
